<template>
  <a>
    <span class="modal-body-text">Are you sure you want to force this user to reset their password?</span><br/>
  </a>
</template>

<script>
export default {
  name: 'force-reset-password-modal',
  props: {
    userId: ''
  }
}
</script>

<style lang="less">

</style>




// WEBPACK FOOTER //
// ForceUserResetPassword.vue?d66d02f4